<script>
import moment from 'moment'

const format = 'YYYY-MM-DD'

export default {
  props: {
    challenge: {
      type: Object
    }
  },

  data() {
    const data = this.challenge

    return {
      name: data ? data.name : '',
      category: data ? data.category : '',
      level: data ? data.level : 1,
      description: data ? data.description : '',
      started_at: data ? moment(data.started_at).format(format) : moment().format(format),
      ended_at: data ? moment(data.ended_at).format(format) : moment().add(2, 'months').format(format)
    }
  },

  methods: {
    save() {
      if (this.isEmpty()) {
        this.$alert({
          type: 'danger',
          trans: 'errors.invalid_fields'
        })

        return
      }

      const data = {
        name: this.name,
        category: this.category,
        level: this.level,
        description: this.description,
        started_at: this.started_at,
        ended_at: this.ended_at
      }

      if (this.challenge) {
        this.axios.put('/challenges/' + this.challenge.id, data)
          .then(this.onSaved)
      } else {
        this.axios.post('/challenges', data)
          .then(this.onSaved)
      }
    },

    onSaved() {
      if (!this.challenge) {
        Object.assign(this.$data, this.$options.data.call(this))
      }

      this.$alert({
        type: 'success',
        trans: 'messages.challenge_added'
      })
    },

    isEmpty() {
      return !(
        this.name &&
        this.description &&
        this.started_at &&
        this.ended_at &&
        ['DEV', 'DESIGN'].indexOf(this.category) > -1 &&
        [1, 2, 3].indexOf(this.level) > -1
      )
    }
  }
}
</script>

<template>
    <form @submit.prevent="save" class="box">
      <div class="field">
        <label for="name">Nom</label>
        <input type="text" class="input" id="name" v-model.trim="name">
      </div>

      <div class="field">
        <label for="category">Catégorie</label>
        <br>
        <div class="select">
          <select id="category" v-model.trim="category">
            <option value="">Choisir un catégorie</option>
            <option value="DESIGN">DESIGN</option>
            <option value="DEV">DEV</option>
          </select>
        </div>
      </div>

      <div class="field">
        <label for="level">Niveau</label>
        <br>
        <div class="select">
          <select id="level" v-model.trim.number="level">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
          </select>
        </div>
      </div>

      <div class="field">
        <label for="description">Description</label>
        <br>
        <textarea type="text" class="input" id="description" v-model.trim="description"></textarea>
      </div>

      <div class="field">
        <label for="started_at">Date de début</label>
        <input type="text" class="input" id="started_at" v-model.trim="started_at">
      </div>

      <div class="field">
        <label for="ended_at">Date de fin</label>
        <input type="text" class="input" id="ended_at" v-model.trim="ended_at">
      </div>

      <div class="field has-text-centered">
        <button class="button is-success">
          Ajouter
        </button>
      </div>
    </form>
</template>

<style scoped>
textarea {
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChallengeForm.vue